import React from "react";
import ReactMarkdown from "react-markdown";

const AcademySection5 = ({ academy }) => {
  const components = {
    p: ({ children }) => (
      <p className="text-[#666666] mb-2 max-w-2xl text-sm mx-auto">
        {children}
      </p>
    ),
    ul: ({ children }) => (
      <ul className="list-disc pl-0 mb-6 text-gray-600 max-w-2xl ">
        {children}
      </ul>
    ),
    li: ({ children }) => <li className="mb-2">{children}</li>,
    br: () => <br />,
  };

  return (
    <div className="py-2 px-6 bg-white mt-10">
      <div className="container mx-auto">
        <div className="mb-">
          <h2 className="text-xl text-left font-bold text-[rgba(62,89,183,1)] mb-2">
            Outcomes
          </h2>
        </div>
        <div className="rounded-2xl px-4 text-left">
          <ReactMarkdown components={components}>
            {academy.academyOutcome}
          </ReactMarkdown>
        </div>
      </div>
    </div>
  );
};

export default AcademySection5;
